/**
 * TeamInfo - Componente presentacional para mostrar información de un equipo
 * 
 * Props:
 *   - lineup: Objeto con datos del equipo (manager, formation, starters)
 *   - teamName: Nombre del equipo (ej: 'Real Madrid', 'Barcelona')
 *   - classModifier: Modificador CSS para el equipo ('home' o 'away')
 */

export default function TeamInfo({ lineup = null, teamName = "", classModifier = "home" }) {
  if (!lineup) {
    return null;
  }

  /**
   * Obtiene el capitán del equipo desde los jugadores titulares
   * Valida que exista el jugador y que tenga nombre y número
   * @returns {Object|null} - Objeto con {name, shirt} o null
   */
  const getCaptain = () => {
    if (!lineup.starters || !Array.isArray(lineup.starters)) {
      return null;
    }

    const captain = lineup.starters.find(player => player?.captain === true);

    if (!captain) {
      return null;
    }

    // Validar que el capitán tenga nombre válido
    const captainName = captain?.name?.trim();
    if (!captainName) {
      return null;
    }

    // Validar que el capitán tenga número válido
    const captainNumber = captain?.shirt;
    if (captainNumber === null || captainNumber === undefined || captainNumber === "") {
      return { name: captainName, shirt: null };
    }

    return { name: captainName, shirt: captainNumber };
  };

  const captain = getCaptain();

  return (
    <div className={`team-info-box team-info-box--${classModifier}`}>
      <h3 className="team-title">{teamName}</h3>
      <p className="formation-info"><span>Formación:</span> {lineup.formation}</p>
      {lineup.manager && (
        <p className="manager-info"> <span>Entrenador:</span> {lineup.manager}</p>
      )}
      {captain && (
        <p className="captain-info">
          <span className="capitan">C</span> {captain.name}
          {captain.shirt !== null && <span> #{captain.shirt}</span>}
        </p>
      )}
    </div>
  );
}
